import dynamic from 'next/dynamic';

const PdfViewer = dynamic(() => import('./pdfViewerClient'), {
  ssr: false
});

export default PdfViewer;
